import TokenService from '../services/token-service';
import { ApiService } from '../services/api-main';
import { $api } from '../services/api';
import QRGenerator from 'qrcode';

import lottie from 'lottie-web';
import loadingDefault from '@/assets/img/loading/loading_wandr_default.json';
import VueApp from '../main.js'

import defaultBankImg from '@/assets/img/bank/0.jpg';
import defaultCountryImg from '@/assets/img/flags/flag_rect_253.png';
import defaultFlagImg from '@/assets/img/flags/flag_0.png';

export default {
    install (Vue) {
        Vue.mixin({
            computed: {
              $api: () => $api
            },
            methods: {
                setInputState(inputEl, state){
                    /*
                      NOTE:
                        VALID   -> state = true
                        NEUTRAL -> state = false
                        INVALID -> state = "anystring"
                    */

                    let $thisParent = typeof inputEl == 'string'
                                    ? this.$$('.page.page-current #'+inputEl).length > 1 ? this.$$('.page.page-current #'+inputEl).closest('li') : this.$$('.page.page-current [name='+inputEl+']').closest('li')
                                    : this.$$(inputEl).closest('li')
                    let isInline = false;

                    if ( $thisParent.hasClass('item-inline-input') ) {
                      $thisParent = $thisParent.closest("li.inline-input");
                      isInline = true;
                    }

                    if ( this.$_.isBoolean(state) ){
                      if(state) {
                        $thisParent
                          .addClass('item-input-valid')
                          .removeClass('item-input-with-error-message item-input-invalid')
                          .find('.item-input-error-message').remove()
                      } else {
                        $thisParent
                          .removeClass('item-input-valid item-input-with-error-message item-input-invalid')
                          .find('.item-input-error-message').remove()
                      }
                    } else if ( this.$_.isString(state) && state !== "" ){
                      $thisParent.addClass('item-input-with-error-message item-input-invalid').removeClass('item-input-valid')

                      if ( $thisParent.find('.item-input-error-message').length == 0 ) {
                        if ( isInline ) {
                          $thisParent.append('<div class="item-input-error-message horizontal-padding"></div>')
                        } else if ( $thisParent.find('.item-checkbox').length >= 1 || $thisParent.hasClass("fx-amount-row")) {
                          $thisParent.append('<div class="item-input-error-message mt-2"></div>')
                        } else {
                          $thisParent.find(".item-input-wrap").append('<div class="item-input-error-message mt-2"></div>')
                        }
                      }

                      $thisParent.find('.item-input-error-message').html(state)
                    }
                },

                preventInvalidNumericInput(event) {
                  // console.log(event.keyCode)
                  // Valid key: backspace, enter, delete, left, right
                  const validKey = [8, 13, 46, 37, 39];
                  if (validKey.includes(event.keyCode)) {
                    return true;
                  }
                  if (!/^[0-9.]+$/.test(event.key)) {
                    event.preventDefault();
                  }
                },

                shiftStepNavbar(){
                  // shifts process step's navbar. no need to call it on first step.
                  let $segmented = this.$$('.subnavbar-inner .segmented')
                  if(!$segmented.hasClass('shifted')){
                    let $activeEl = this.$$('.tab-link-active')
                    let index = $activeEl.length - 1
                    let currentStep = $activeEl.eq(index)[0]
                    let subNavbar = this.$$('.subnavbar-inner .segmented')[0]

                    let thisSetting = {
                        subNavbarRightOffset: subNavbar.offsetLeft + subNavbar.offsetWidth,
                        stepRightOffset: currentStep.offsetLeft + currentStep.offsetWidth
                    }

                    if(thisSetting.stepRightOffset > thisSetting.subNavbarRightOffset){
                      let shift = thisSetting.stepRightOffset - parseInt(thisSetting.subNavbarRightOffset)
                      $segmented.css('marginLeft', '-'+shift+'px').addClass('shifted')
                    }
                  }
                },
                showPreloader(req){
                    let reqLoadingClass = req == "on-green" || req == "on-dark" ? req : 'on-dark'
                    let $loadingWandr = this.$$('#wandr-page-loading')
                    // let loadingJSON = reqLoadingClass == 'on-green' ? loadingDefault : loadingOnDark
                    if ( $loadingWandr.html().length == 0 || !($loadingWandr.hasClass(reqLoadingClass))) {
                        $loadingWandr.html("")
                        lottie.loadAnimation({
                            container: $loadingWandr[0],
                            renderer: 'svg',
                            loop: true,
                            autoplay: true,
                            animationData: loadingDefault
                        })
                        $loadingWandr.removeClass('on-green on-dark').addClass(reqLoadingClass)
                    }
                    $loadingWandr.addClass('show')
                },
                hidePreloader (){
                    this.$$('#wandr-page-loading').removeClass('show')
                },
                checkUpdateAccountVerification(isEditEmail, isEditMobileNo, oldEmail, newEmail, oldMobileCountryId, oldMobileNo, newMobileCountryId, newMobileNo, appleIdToken, onSuccess){
                    const params = {
                        title: VueApp.$t('label-enter-pin'),
                        text: "",
                        closeByBackdrop: true,
                        closeByOutside: true,
                        isEditEmail: isEditEmail,
                        isEditMobileNo: isEditMobileNo,
                        oldEmail: oldEmail,
                        newEmail: newEmail,
                        oldMobileNo: oldMobileNo,
                        newMobileNo: newMobileNo,
                        oldMobileCountryId: oldMobileCountryId,
                        newMobileCountryId: newMobileCountryId,
                        submitButtonText: VueApp.$t('general-text-confirm'),
                        appleIdToken: appleIdToken,
                        onSuccess: () => {
                            return (typeof onSuccess === 'function') ? onSuccess() : '';
                        }
                    };
                    
                    //Vue.prototype.$sessionRefreshModal.setProps(params)
                    Vue.prototype.$sessionRefreshModal.show(params)
                },
                checkTokenExpiry(bypassCheckState, onSuccess) {
                    const isAxsr = this.$store.state.registration.isAxsr;
                    const currentPath = VueApp.$f7.views.main.router.currentRoute.path;
                    //console.log("Mixin checkTokenExpiry, isAxsr : "+isAxsr+" ## "+currentPath)

                    const params = {
                        title: "",
                        text: "",
                        onSuccess: () => {
                            return (typeof onSuccess === 'function') ? onSuccess() : '';
                        }
                    };

                    /*// for testing
                    if(isAxsr && currentPath == "/customerDetails"){
                      VueApp.navigateRoute("/axsr-login");
                      Vue.prototype.$sessionRefreshModal.show(params)
                      return false
                    }
                    // end for testing */

                                     
                    if (VueApp.$api.customer.getSessionId() && (bypassCheckState || this.$store.state.auth.loggedIn) && (this.$f7.views.main.router.url != "/reset-password-email?pid=popup" && this.$f7.views.main.router.url != "/reset-password-email?pid=login")) {
                        //console.log("CURR URL : "+ this.$f7.views.main.router.url)
                        var displayModal = false
                        var isShowAXSLogin = false
                        const tokenExpiry = new Date(TokenService.getTokenExpiry())
                        const now = new Date()
                        if (tokenExpiry == undefined || tokenExpiry == null) {
                            if(isAxsr && currentPath == "/customerDetails"){
                              VueApp.navigateRoute("/axsr-login");
                              isShowAXSLogin = true
                              displayModal = true
                            }else{
                              displayModal = true
                            }
                        } else if (tokenExpiry.getTime() > now.getTime()) {
                            const diff = tokenExpiry - now
                            const diffInSec = diff/1000
                            if (diffInSec <= process.env.VUE_APP_TOKEN_BUFFER) {
                                // Auto Refresh Token
                                this.$store.dispatch('auth/refreshToken')
                            }
                        } else if (tokenExpiry <= now) {
                          if(isAxsr && currentPath == "/customerDetails"){
                            VueApp.navigateRoute("/axsr-login");
                            isShowAXSLogin = true
                            displayModal = true
                          }else{
                            displayModal = true
                          }
                        }

                        if (displayModal) {
                          if (!isShowAXSLogin && (window.Android || window.webkit)) {
                            this.navigateToPath(window.location.href)
                          }
                          Vue.prototype.$sessionRefreshModal.show(params)
                          return false
                        } else {
                          return true
                        }
                    }
                    return true;
                    
                },
                isTokenValid() {
                  const tokenExpiry = new Date(TokenService.getTokenExpiry())
                  const now = new Date()
                  if (tokenExpiry == undefined || tokenExpiry == null) {
                    return false
                  } else if (tokenExpiry.getTime() > now.getTime()) {
                    return true
                  } else if (tokenExpiry <= now) {
                    return false
                  }
                },
                generateQR(canvas, text, size){

                  QRGenerator.toCanvas(canvas, text, { width: size }, function (error) {
                    if (error) console.error(error)
                    console.log('success!');
                  })

                },
                generate7ElevenQR(canvas, settlementId, size){

                  QRGenerator.toCanvas(canvas, '{"v":"P2H","a":"'+settlementId+'"}', { width: size }, function (error) {
                    if (error) console.error(error)
                    console.log('success!');
                  })

                },
                navigateBackEventHook(path) { // Don't use this function.
                  console.log('path:'+path)
                  const self = this
                  this.$$('.page-current .navbar .customBack').once('click', function () {
                    // VueApp.$f7.views.main.router.navigate(path, {animate: false})
                    VueApp.$f7.views.main.router.back({force: true})

                    if (!VueApp.isTokenValid()) {
                      self.$$('.page-current .navbar .customBack').once('click', function () {
                        VueApp.$f7.views.main.router.back({force: true})
                      })
                    }
                  });
                },
                navigateToPath(path) {
                  try {
                    const url = new URL(path);
                    if(path.includes(location.host)) {
                      if(url.hash != '') {
                        VueApp.navigateRoute(url.hash.replace('#!', ''));
                      } else {
                        VueApp.navigateRoute(url.pathname + url.search);
                      }
                    } else {
                      window.open(url, '_blank');
                    }
                  } catch(e) {
                    const paths = path.split("?");
                    if(paths.length == 1) {
                      VueApp.navigateRoute(path);
                    } else if(paths[0].includes('/notification/detail')) {
                      const moment = require('moment');
                      const obj = JSON.parse(paths[1]);
                      const date = moment(obj.date, "DD-MM-YYYY");
                      var message = this.$store.state.misc.message;
                      message.id               = obj.id
                      message.title            = ''
                      message.subject          = obj.subject
                      message.date             = date.format("DD MMMM YYYY")
                      message.content          = obj.content
                      message.read             = obj.read
                      VueApp.navigateRoute("/notification/detail");
                    } else if(paths.length > 1) {
                      try {
                        // Uncomment below code if in the future needs more options setting
                        // var queries = [];
                        // for (let i = 1; i < paths.length; i++) {
                        //   queries.push(JSON.parse(paths[i]));
                        // }
                        // console.log(...queries);
                        VueApp.navigateRoute(paths[0], paths[1]);
                        // Example: window.navigatePushNotificationTo('/verify/take-photo?{"props":{"doc":{"id":0,"name":"Identity Document"},"isFromHome":true}}')
                      } catch (e) {
                        VueApp.navigateRoute(path);
                      }
                    }
                  }
                },
                navigateRoute(path, params) {
                  this.$store.state.misc.redirectToPath = '';
                  const alive = this.$store.state.auth.loggedIn && VueApp.isTokenValid();
                  const hasParam = (params != '' && params != undefined);
                  if(path.includes('login') || path.includes('reset') || path.includes('guest')) {
                    if(TokenService.getToken()) {
                      this.$store.dispatch('auth/logout');
                      VueApp.$f7.sheet.close();
                    }
                    VueApp.$f7.views.main.router.navigate(path, { ignoreCache : true, clearPreviousHistory  : true });
                  } else if(alive && hasParam) {
                    VueApp.$f7.views.main.router.navigate(path, JSON.parse(params));
                  } else if(alive) {
                    VueApp.$f7.views.main.router.navigate(path);
                  } else if(TokenService.getToken() && hasParam) {
                    this.$store.state.misc.redirectToPath = path + '?' + params;
                  } else if(TokenService.getToken()) {
                    this.$store.state.misc.redirectToPath = path;
                  }
                },
                googleSignInResponse(response) {
                  VueApp.showPreloader();
                  if(VueApp.$f7.views.main.router.url == '/register') {
                    VueApp.$api.customer.googleRegister(response.access_token).then(function(result) {
                      VueApp.hidePreloader();
                      if(result.status == "WN00118") {
                        VueApp.$f7.views.main.router.navigate('/register-input-password');
                      } else {
                        VueApp.$f7.dialog.alert(result.message)
                      }
                    });
                  } else {
                    VueApp.$api.customer.googleLogin(response.access_token).then(function(result) {
                      VueApp.hidePreloader();
                      if(result.status == '0100') { // SUCCESS
                        VueApp.registerDeviceTokenCustomer(result.result.p2hCustomerId);
                        VueApp.setCustomerUsingBiometry(result.result.p2hCustomerId, 2);
                        VueApp.$f7.views.main.router.navigate('/home');
                      } else if(result.status == "0105") { // ACCOUNT SUSPENDED
                        VueApp.$f7.dialog.alert(VueApp.$t('reset-password-email-inactive'))
                      } else if(result.status == "WN00102") { // MULTIPLE EMAIL FOUND
                        VueApp.$f7.dialog.alert(VueApp.$t('regis-multiple-user-err'))
                      } else if(result.status == "WN00115") { // INVALID EMAIL
                        VueApp.$f7.dialog.alert(VueApp.$t('login-err-WN00115-apple'))
                      } else if(result.status == "WN00117") { // GENERAL
                        VueApp.$f7.dialog.alert(VueApp.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                      } else if(result.status == "WN00118") {
                        VueApp.$f7.views.main.router.navigate('/register-input-password');
                      } else {
                        VueApp.$f7.dialog.alert(result.message)
                      }
                    });
                  }

                  VueApp.closePopupOnMobile();
                },
                appleSignInResponse(method, response) {
                  VueApp.showPreloader();
                  VueApp.$api.customer.appleLogin(response, false).then(function(result) {
                    VueApp.hidePreloader();
                    if(result.status == '0100') { // SUCCESS
                      VueApp.registerDeviceTokenCustomer(result.result.p2hCustomerId);
                      VueApp.setCustomerUsingBiometry(result.result.p2hCustomerId, 2);
                      VueApp.$f7.views.main.router.navigate('/home');
                    } else if(result.status == "0105") { // ACCOUNT SUSPENDED
                      VueApp.$f7.dialog.alert(VueApp.$t('reset-password-email-inactive'))
                    } else if(result.status == "WN00102") { // MULTIPLE EMAIL FOUND
                      VueApp.$f7.dialog.alert(VueApp.$t('regis-multiple-user-err'))
                    } else if(result.status == "WN00115") { // INVALID EMAIL
                      VueApp.$f7.dialog.alert(VueApp.$t('login-err-WN00115-apple'))
                    } else if(result.status == "WN00117") { // GENERAL
                      VueApp.$f7.dialog.alert(VueApp.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                    } else if(result.status == "WN00118") {
                      VueApp.$f7.sheet.close();
                      if(result.result.hidePass == 1){
                        VueApp.$f7.views.main.router.navigate('/register-tnc');
                      }else{
                        VueApp.$f7.views.main.router.navigate('/register-input-password');
                      }
                    } else {
                      VueApp.$f7.dialog.alert(result.message)
                    }
                  });

                  VueApp.closePopupOnMobile();
                },
                appleSignUpResponse(response) {
                  VueApp.showPreloader();
                  VueApp.$api.customer.appleRegister(response).then(function(result) {
                    VueApp.hidePreloader();
                    if(result.status == "WN00118") {
                      if(result.result.hidePass == 1){
                        VueApp.$f7.views.main.router.navigate('/register-tnc');
                      }else{
                        VueApp.$f7.views.main.router.navigate('/register-input-password');
                      }
                    } else {
                      VueApp.$f7.dialog.alert(result.message)
                    }
                  });

                  VueApp.closePopupOnMobile();
                },
                async appleSignIn(method, isFromNative) {
                  if(window.webkit && !isFromNative) {
                    VueApp.showPreloader();
                    window.webkit.messageHandlers.WandrCallbackHandler.postMessage(JSON.stringify({ "type": 'sign_in_with_apple', "method": method }));
                  } else {
                    try {
                      const response = await window.AppleID.auth.signIn();
                      if(method == 1) { // Login
                        this.appleSignInResponse(method, response.authorization.id_token);
                      } else if(method == 2) { // Register
                        this.appleSignUpResponse(response.authorization.id_token);
                      } else if(method == 3 || method == 4) { // Refresh Session or Edit Email or Edit Mobile Number
                        VueApp.$emit("handleApleValidationStatus", response.authorization.id_token);
                        VueApp.closePopupOnMobile();
                      }
                    } catch (error) {
                      console.log(error);
                      this.closePopupOnMobile();
                    }
                  }
                },
                closePopupOnMobile() {
                  if(window.Android) {
                    window.Android.getWandrCallback(JSON.stringify({ "type": 'close_popup' }));
                  } else if(window.webkit) {
                    window.webkit.messageHandlers.WandrCallbackHandler.postMessage(JSON.stringify({ "type": 'close_popup' }));
                  }
                },
                getBankImg(bankId){
                    try {
                        let bankImg = require('@/assets/img/bank/' + bankId + '.jpg')
                        return bankImg;
                    } catch (e) {
                        return defaultBankImg;
                    }
                },
                getCountryImg(countryId){
                    try {
                        let countryFXImg = require('@/assets/img/flags/flag_rect_' + countryId + '.png')
                        return countryFXImg;
                    } catch (e) {
                        return defaultCountryImg;
                    }
                },
                getFlagImg(countryId){
                    try {
                        var flagImg = require('@/assets/img/flags_/flag_circle_' + countryId +'.png')
                        return flagImg;
                    } catch (e) {
                        return defaultFlagImg;
                    }
                },
                getCircleSmallFlagImg(countryId){
                    try {
                        var flagImg = require('@/assets/img/flags/flag_circle_small_' + countryId +'.png')
                        return flagImg;
                    } catch (e) {
                        return defaultFlagImg;
                    }
                },
                getImg(path){
                  try {
                      var img = require('@/assets/img/' + path)
                      return img;
                  } catch (e) {
                      return defaultFlagImg;
                  }
                },
                registerDeviceTokenCustomer(customerId) {
                  if(!ApiService.getFormData('PTD') || ApiService.getFormData('PN_DEVICE_UUID')) {
                    return false;
                  }

                  if(window.Android || window.webkit) {
                    this.$store.state.customer.customerId = customerId;
                    const data = JSON.parse(ApiService.getFormData('PTD'));
                    VueApp.$api.pushnotification.registerDeviceToken(data.t, data.u, data.c).then(function() {
                      //console.log(result);
                    });
                  }
                },
                registerPushNotification(token, uuid, carrier) {
                  VueApp.$api.pushnotification.registerDeviceToken(token, uuid, carrier).then(function() {
                    //console.log(result);
                  });
                },
                toggleFooterVisibility(state){
                  // state can be boolean or e.target
                  if(typeof state != 'boolean') {
                    // 40 is extra bottom padding.
                    state = state.scrollHeight - state.scrollTop - 40 <= state.clientHeight;
                  }
                  if (state) {
                    this.$$('#page-footer').addClass("show")
                  } else {
                    this.$$('#page-footer').removeClass("show")
                  }
                },
                logoutPushNotification() {
                  VueApp.$api.pushnotification.logoutDevice().then(function() {
                    //console.log(result);
                  });
                },
                checkBiometryAvaibility() {
                  if(window.Android) {
                    window.Android.getWandrCallback(JSON.stringify({ "type": "check_biometry" }));
                  } else if(window.webkit) {
                    window.webkit.messageHandlers.WandrCallbackHandler.postMessage(JSON.stringify({ "type": "check_biometry" }));
                  }
                },
                getVersionApp(){
                  if(window.Android) {
                    window.Android.getWandrCallback(JSON.stringify({ "type": "get_version" }));
                  } else if(window.webkit) {
                    window.webkit.messageHandlers.WandrCallbackHandler.postMessage(JSON.stringify({ "type": "get_version" }));
                  }
                },
                openDeviceBiometry() {
                  const data = JSON.stringify({ "type": "open_biometry", 'token': TokenService.getToken() });
                  if(window.Android) {
                    window.Android.getWandrCallback(data);
                  } else if(window.webkit) {
                    window.webkit.messageHandlers.WandrCallbackHandler.postMessage(data);
                  }
                },
                validateBiometryToken(token) {
                  if(token == '') {
                    VueApp.$emit("handleValidationBiometryStatus", false);
                    return false;
                  }
                  VueApp.showPreloader();
                  VueApp.$api.customer.validateBiometric(token).then(function(result) {
                    VueApp.hidePreloader();
                    if(result === undefined || result.length <= 0) {
                      VueApp.$emit("handleValidationBiometryStatus", false);
                      VueApp.$f7.dialog.alert(VueApp.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                    } else if(result.status == "WN00000") {
                      VueApp.setCustomerUsingBiometry(result.result.p2hCustomerId, 1);
                      VueApp.$emit("handleValidationBiometryStatus", true);
                    } else if(result.status == "WN00005") {
                      VueApp.$emit("handleValidationBiometryStatus", false);
                      VueApp.$f7.sheet.close();
                      VueApp.$f7.dialog.alert(VueApp.$t('reset-password-email-inactive'), function(){
                        VueApp.navigateRoute('/login');
                      });
                    } else {
                      VueApp.$emit("handleValidationBiometryStatus", false);
                      VueApp.$f7.dialog.alert(VueApp.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                    }
                  });
                },
                getMakeYourPaymentDate(dateVal){
                  var inputFormat = null

                  if(dateVal == undefined){
                    var tomorrow = new Date()
                    inputFormat = tomorrow.setDate(new Date().getDate()+1)
                  }else{
                    let createdDateString = dateVal.year + "/" + (dateVal.month + 1) + "/" + dateVal.dayOfMonth + " " + dateVal.hourOfDay + ":" + dateVal.minute
                    const createDate      = new Date(createdDateString);
                    inputFormat  = createDate.setDate(createDate.getDate()+1)
                  }

                  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec" ]
                  function pad(s) { return (s < 10) ? '0' + s : s; }
                  var d = new Date(inputFormat)
                  return ( [pad(d.getDate()), pad(monthNames[d.getMonth()]), d.getFullYear()].join(' ') ) +", "+ this.$store.state.transaction.paymentTime
                },

                getDateFormat(dateVal, showTime){
                  let createdDateString = dateVal.year + "/" + (dateVal.month + 1) + "/" + dateVal.dayOfMonth + " " + dateVal.hourOfDay + ":" + dateVal.minute
                  const createdDate     = new Date(createdDateString);
                  const months          = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
                  let timeExtend        = createdDate.getHours() >= 12 ? ' PM' : ' AM'
                  let hours             = (createdDate.getHours() % 12) || 12

                  if(showTime){
                    return (
                      createdDate.getDate() + ' ' + months[createdDate.getMonth() ] +" " + createdDate.getFullYear() +  ', '
                      + ('0'+hours).slice(-2) + "." + ('0'+createdDate.getMinutes()).slice(-2) + timeExtend
                    )
                  }else{
                    return ( createdDate.getDate() + ' ' + months[createdDate.getMonth() ] +" " + createdDate.getFullYear() )
                  }
                },

                getDateMonthFormat(dateVal){
                  let createdDateString = dateVal.year + "/" + (dateVal.month + 1) + "/" + dateVal.dayOfMonth + " " + dateVal.hourOfDay + ":" + dateVal.minute
                  const createdDate     = new Date(createdDateString);
                  const months          = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

                  return ( months[createdDate.getMonth() ] +" " + createdDate.getFullYear() )
                },

                checkPreventOnlySpecial(field) {
                  var specialList  = ['.', ',', '!', '!', '{ ', '}', '<', '>', '?', ':', ';', '\u2013', '\u2014', '-', '(', ')', '[', ']', '\'', '"', '\u2018', '\u0060', '\u2019', '\u201C', '\u201D', '^', '@', '~', '`', '$', '%', '*', '_', '|', '/', '&'];
                  var val          = field;
                  var removedWhite = val.replace(/\s+/g,'');
                  var len          = val.length, removedLen = removedWhite.length;
                  var i            = 0, spcCount = 0, checkChar = 0;
                  if(len == 0) { // must not be empty!
                    return -1;
                  } else if(removedLen == 0) { // considered error, because the value contains only white spaces.
                    return -2;
                  } else {
                    spcCount = 0;
                    for(i = 0; i < removedLen; i++) {
                      checkChar = removedWhite.charAt(i);
                      if(specialList.indexOf(checkChar)>-1) { // if in list of Special Character, add to count.
                        spcCount++;
                      }
                    }
                    if(spcCount == removedLen) { // considered error, because the value contains only special characters.
                      return -3;
                    } else {
                      return 0;
                    }
                  }
                },

                isDisplay(countryId) {
                  return process.env.VUE_APP_SUPPORTED_COUNTRIES.includes(countryId)
                },

                setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId, type = null, linkId = null, searchbarId = null){
                  //console.log("setDropdownDirection : "+type+" ## "+inputListId)
                  const self    = this;

                  /*
                    72 = height of toolbar-with-button
                    56 = height of back button
                  */

                  var openedDirection = "";

                  var initHeight = parseFloat(this.$store.state.misc.initScreenHeight);
                  var fullHeight = parseFloat(this.$store.state.misc.screenHeight); //parseFloat(window.innerHeight);
                  var halfHeight = parseFloat(fullHeight/2);

                  window.addEventListener('resize', async () => {
                    fullHeight = parseFloat(this.$store.state.misc.screenHeight); //parseFloat(window.innerHeight);
                    halfHeight = parseFloat(fullHeight/2);
                    initHeight = parseFloat(this.$store.state.misc.initScreenHeight);
                  });

                  
                  self.Dom7(popover).on('popover:open', function () {
                      self.$$(popover).css({
                          'visibility' : 'hidden',
                      });
                  });

                  
                  self.Dom7(popover).on('popover:opened', async function () {
                    var thepopover = self.Dom7(popover);
                    const classes = thepopover[thepopover.length-1].firstChild.classList;
                    const popoverDirection = classes[1];
                    //console.log("POPVER ANGLE DIRECTION : "+popoverDirection)

                    const countryCodeWidth = 100
                    const margin1x = 8 
                    let inputHeight = 54
                    const parentPosBottom = parseFloat(document.getElementById(inputId).getBoundingClientRect().bottom);
                    const parentPosTop = parseFloat(document.getElementById(inputId).getBoundingClientRect().top);
                    var parentPosLeft = parseFloat(document.getElementById(inputId).getBoundingClientRect().left);
                    var parentWidth = parseFloat(document.getElementById(inputId).getBoundingClientRect().width);

                    //var linkIdPosLeft = 0; 
                    if(type == "mobile-input"){
                      //linkIdPosLeft = parseFloat(document.getElementById(linkId).getBoundingClientRect().left);
                      parentWidth = parentWidth + countryCodeWidth + margin1x                    }

                    if(type == "fx-calculator"){
                      inputHeight = 60

                      parentPosLeft = 0 //parseFloat(document.getElementById(inputListId.substring(1)).getBoundingClientRect().left) - 24; // 24 = margin
                      parentWidth = parseFloat(document.getElementById(linkId).getBoundingClientRect().width);
                    }

                    const maxHeightBottom = fullHeight - parentPosBottom - 72;
                    const maxHeightAbove = parentPosTop - 56;

                    //console.log("screenHeight: "+fullHeight+"\nhalfHeight: "+halfHeight+"\nparentPosTop: "+parentPosTop+"\nparentPosBottom: "+parentPosBottom+"\nmaxHeightAbove: "+maxHeightAbove+"\nmaxHeightBottom: "+maxHeightBottom)

                    if(type == "mobile-input" || type == "fx-calculator"){
                      self.$$(".mobile-input #"+linkId).removeClass("dropdown-list").addClass("dropdown-list");
                    }else{
                      self.$$(inputListId).removeClass("dropdown-list").addClass("dropdown-list");
                    }


                    // POPOVER DIRECTION - OPEN IN BOTTOM
                    if(popoverDirection == "on-top" || popoverDirection == "on-left" || popoverDirection == "on-right"){
                      //console.log("POPVER OPEN IN BOTTOM");
                      openedDirection = "bottom";
                      if(parentPosTop >= halfHeight ){
                        //console.log("CHANGED TO OPEN IN ABOVE")
                        openedDirection = "above";
                        await self.$$(popoverInner).css({
                            'max-height' : (maxHeightAbove) + 'px',
                        });

                        let newHeight1 = parseFloat(document.querySelector("#"+popoverId+".modal-in").offsetHeight);

                        const tmpTop = fullHeight - ( (fullHeight - parentPosBottom) + newHeight1) - inputHeight - margin1x
                        
                        if((type == "mobile-input" || type == "fx-calculator") && popoverDirection == "on-right"){
                          if(type == "mobile-input"){
                            self.$$(popover).css({
                              'left' : (parentPosLeft + countryCodeWidth + margin1x) + 'px',
                            });
                          }

                          self.$$(popover).css({
                              'visibility' : 'visible',
                              'margin-top' : (margin1x) + 'px',
                              'margin-left' : (parentPosLeft + countryCodeWidth + margin1x) + 'px',
                              'width' : parentWidth + 'px',
                              'top' : (tmpTop) + 'px'
                          });
                        }else if((type == "mobile-input" || type == "fx-calculator") && popoverDirection == "on-left"){
                          if(type == "mobile-input"){
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'margin-top' : (margin1x) + 'px',
                                'left' : (parentPosLeft - countryCodeWidth - margin1x) + 'px',
                                'width' : parentWidth + 'px',
                                'top' : (tmpTop) + 'px'
                            });
                          }else{
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'margin-top' : (margin1x) + 'px',
                                'margin-left' : (parentPosLeft - countryCodeWidth - margin1x) + 'px',
                                'width' : parentWidth + 'px',
                                'top' : (tmpTop) + 'px'
                            });
                          }
                        }else{
                          if(type == "mobile-input"){
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'margin-top' : (margin1x) + 'px',
                                'left' : (parentPosLeft) + 'px',
                                'width' : parentWidth + 'px',
                                'top' : (tmpTop) + 'px'
                            });
                          }else{
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'margin-top' : (margin1x) + 'px',
                                'margin-left' : (parentPosLeft) + 'px',
                                'width' : parentWidth + 'px',
                                'top' : (tmpTop) + 'px'
                            });
                          }
                        }
                      }else{
                        //console.log("POPVER STILL OPEN IN BOTTOM");
                        openedDirection = "bottom";
                        if((type == "mobile-input" || type == "fx-calculator") && popoverDirection == "on-right"){
                          if(type == "mobile-input"){
                            self.$$(popover).css({
                              'left' : (parentPosLeft + countryCodeWidth + margin1x) + 'px',
                            });
                          }

                          self.$$(popover).css({
                              'visibility' : 'visible',
                              'top' : (parentPosBottom) + 'px',
                              'margin-left' : (parentPosLeft + countryCodeWidth + margin1x) + 'px',
                              'margin-top' : (0) + 'px',
                              'width' : parentWidth + 'px',
                          });
                        }else if((type == "mobile-input" || type == "fx-calculator") && popoverDirection == "on-left"){
                          if(type == "mobile-input"){
                            self.$$(popover).css({
                              'visibility' : 'visible',
                              'top' : (parentPosBottom) + 'px',
                              'left' : (parentPosLeft - countryCodeWidth - margin1x) + 'px',
                              'margin-top' : (0) + 'px',
                              'width' : parentWidth + 'px',
                            });
                          }else{
                            self.$$(popover).css({
                              'visibility' : 'visible',
                              'top' : (parentPosBottom) + 'px',
                              'margin-left' : (parentPosLeft - countryCodeWidth - margin1x) + 'px',
                              'margin-top' : (0) + 'px',
                              'width' : parentWidth + 'px',
                            });
                          }
                        }else{
                          if(type == "mobile-input"){
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'top' : (parentPosBottom) + 'px',
                                'left' : (parentPosLeft - countryCodeWidth - margin1x) + 'px',
                                'margin-top' : (0) + 'px',
                                'width' : parentWidth + 'px',
                            });
                          }else{
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'top' : (parentPosBottom) + 'px',
                                'margin-left' : (parentPosLeft) + 'px',
                                'margin-top' : (0) + 'px',
                                'width' : parentWidth + 'px',
                            });
                          }
                        }

                        self.$$(popoverInner).css({
                            'max-height' : (maxHeightBottom - (Math.abs(initHeight - fullHeight))) + 'px',
                        });
                      }
                    }
                    // POPOVER DIRECTION - OPEN IN ABOVE
                    else if(popoverDirection == "on-bottom"){
                      //console.log("POPVER OPEN IN ABOVE");
                      openedDirection = "above";
                      if(parentPosBottom < halfHeight ){
                        //console.log("DIRECTION CHANGED : OPEN IN BOTTOM")
                        openedDirection = "bottom";
                        await self.$$(popoverInner).css({
                            'max-height' : (maxHeightBottom - (Math.abs(initHeight - fullHeight))) + 'px',
                        });                        

                        if(type == "mobile-input" || type == "fx-calculator"){
                          if(type == "mobile-input"){
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'top' : (parentPosBottom) + 'px',
                                'left' : (parentPosLeft - countryCodeWidth - 6) + 'px',
                                'margin-top' : (0) + 'px',
                                'width' : parentWidth + 'px',
                            });
                          }else{
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'top' : (parentPosBottom) + 'px',
                                'margin-left' : (parentPosLeft + 2) + 'px',
                                'margin-top' : (0) + 'px',
                                'width' : parentWidth + 'px',
                            });
                          }
                        }else{
                          self.$$(popover).css({
                              'visibility' : 'visible',
                              'top' : (parentPosBottom) + 'px',
                              'margin-left' : (parentPosLeft) + 'px',
                              'margin-top' : (0) + 'px',
                              'width' : parentWidth + 'px',
                          });
                        }
                      }else{
                        //console.log("DIRECTION STILL OPEN IN ABOVE")
                        openedDirection = "above";
                        await self.$$(popoverInner).css({
                            'max-height' : (maxHeightAbove) + 'px',
                        });

                        let newHeight2 = parseFloat(document.querySelector("#"+popoverId+".modal-in").offsetHeight);
                        //console.log("newHeight2: "+newHeight2)

                        const tmpTop = fullHeight - ( (fullHeight - parentPosBottom) + newHeight2) - inputHeight - margin1x
                        
                        if(type == "mobile-input" || type == "fx-calculator"){
                          if(type == "mobile-input"){
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'margin-top' : (margin1x) + 'px',
                                'left' : (parentPosLeft - countryCodeWidth - margin1x - 2) + 'px',
                                'width' : parentWidth + 'px',
                                'top' : (tmpTop) + 'px'
                            });
                          }else{
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'margin-top' : (margin1x) + 'px',
                                'margin-left' : (parentPosLeft + 2) + 'px',
                                'width' : parentWidth + 'px',
                                'top' : (tmpTop) + 'px'
                            });
                          }
                        }else{
                          self.$$(popover).css({
                              'visibility' : 'visible',
                              'margin-top' : (margin1x) + 'px',
                              'margin-left' : (parentPosLeft) + 'px',
                              'width' : parentWidth + 'px',
                              'top' : (tmpTop) + 'px'
                          });
                        }

                      }
                    }


                    self.$store.state.misc.latestCountryCodePopoverDirection = openedDirection;
                    
                    window.onresize = function() {
                        if(type == "mobile-input" && document.querySelector(".popover.modal-in")){
                          self.setPopoverPosition(popover, popoverInner, popoverId, inputId, inputListId, type, linkId, searchbarId, false)
                        }
                    }
                    
                  });
                  
                  self.Dom7(popover).on('popover:closed', function () {
                      if(type == "mobile-input" || type == "fx-calculator"){
                        self.$$(".mobile-input #"+linkId).removeClass("dropdown-list")
                        self.$f7.searchbar.clear(self.Dom7("#"+searchbarId))
                      }else{
                        self.$$(inputListId).removeClass("dropdown-list")
                      }
                  });
                },

                setPopoverPosition(popover, popoverInner, popoverId, inputId, inputListId, type = null, linkId = null, searchbarId = null, isHeightChanged){
                  if(linkId == "" && searchbarId == ""){console.log("empty")}
                  if(document.querySelector("#"+popoverId+".modal-in")){
                    const self = this;

                    if(isHeightChanged){
                      const newHeight = parseFloat(document.querySelector("#"+popoverId+".modal-in").offsetHeight);
                      //console.log("new H: "+newHeight)
                      if(newHeight <= 0){console.log("H=0")}
                    }

                    var initHeight = parseFloat(this.$store.state.misc.initScreenHeight);
                    var fullHeight = parseFloat(this.$store.state.misc.screenHeight); //parseFloat(window.innerHeight);
                    var halfHeight = parseFloat(fullHeight/2);

                    var thepopover = self.Dom7(popover);
                    const classes = thepopover[thepopover.length-1].firstChild.classList;
                    const popoverDirection = classes[1];

                    const countryCodeWidth = 100
                    const margin1x = 8 
                    let inputHeight = 54
                    const parentPosBottom = parseFloat(document.getElementById(inputId).getBoundingClientRect().bottom);
                    const parentPosTop = parseFloat(document.getElementById(inputId).getBoundingClientRect().top);
                    var parentPosLeft = parseFloat(document.getElementById(inputId).getBoundingClientRect().left);
                    var parentWidth = parseFloat(document.getElementById(inputId).getBoundingClientRect().width);

                    const maxHeightBottom = fullHeight - parentPosBottom - 72;
                    const maxHeightAbove = parentPosTop - 56;

                    if(type == "mobile-input"){
                      parentWidth = parentWidth + countryCodeWidth + margin1x                    
                    }


                    // POPOVER DIRECTION - OPEN IN BOTTOM
                    if(popoverDirection == "on-top" || popoverDirection == "on-left" || popoverDirection == "on-right"){
                      //console.log("POPVER OPEN IN BOTTOM");
                      if(parentPosTop >= halfHeight ){
                        //console.log("CHANGED TO OPEN IN ABOVE")
                        self.$$(popoverInner).css({
                            'max-height' : (maxHeightAbove) + 'px',
                        });

                        let newHeight1 = parseFloat(document.querySelector("#"+popoverId+".modal-in").offsetHeight);

                        const tmpTop = fullHeight - ( (fullHeight - parentPosBottom) + newHeight1) - inputHeight - margin1x
                        
                        if((type == "mobile-input" || type == "fx-calculator") && popoverDirection == "on-right"){
                          if(type == "mobile-input"){
                            self.$$(popover).css({
                              'left' : (parentPosLeft + countryCodeWidth + margin1x) + 'px',
                            });
                          }

                          self.$$(popover).css({
                              'visibility' : 'visible',
                              'margin-top' : (margin1x) + 'px',
                              'margin-left' : (parentPosLeft + countryCodeWidth + margin1x) + 'px',
                              'width' : parentWidth + 'px',
                              'top' : (tmpTop) + 'px'
                          });
                        }else if((type == "mobile-input" || type == "fx-calculator") && popoverDirection == "on-left"){
                          if(type == "mobile-input"){
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'margin-top' : (margin1x) + 'px',
                                'left' : (parentPosLeft - countryCodeWidth - margin1x) + 'px',
                                'width' : parentWidth + 'px',
                                'top' : (tmpTop) + 'px'
                            });
                          }else{
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'margin-top' : (margin1x) + 'px',
                                'margin-left' : (parentPosLeft - countryCodeWidth - margin1x) + 'px',
                                'width' : parentWidth + 'px',
                                'top' : (tmpTop) + 'px'
                            });
                          }
                        }else{
                          if(type == "mobile-input"){
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'margin-top' : (margin1x) + 'px',
                                'left' : (parentPosLeft) + 'px',
                                'width' : parentWidth + 'px',
                                'top' : (tmpTop) + 'px'
                            });
                          }else{
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'margin-top' : (margin1x) + 'px',
                                'margin-left' : (parentPosLeft) + 'px',
                                'width' : parentWidth + 'px',
                                'top' : (tmpTop) + 'px'
                            });
                          }
                        }
                      }else{
                        //console.log("POPVER STILL OPEN IN BOTTOM");
                        if((type == "mobile-input" || type == "fx-calculator") && popoverDirection == "on-right"){
                          if(type == "mobile-input"){
                            self.$$(popover).css({
                              'left' : (parentPosLeft + countryCodeWidth + margin1x) + 'px',
                            });
                          }

                          self.$$(popover).css({
                              'visibility' : 'visible',
                              'top' : (parentPosBottom) + 'px',
                              'margin-left' : (parentPosLeft + countryCodeWidth + margin1x) + 'px',
                              'margin-top' : (0) + 'px',
                              'width' : parentWidth + 'px',
                          });
                        }else if((type == "mobile-input" || type == "fx-calculator") && popoverDirection == "on-left"){
                          if(type == "mobile-input"){
                            self.$$(popover).css({
                              'visibility' : 'visible',
                              'top' : (parentPosBottom) + 'px',
                              'left' : (parentPosLeft - countryCodeWidth - margin1x) + 'px',
                              'margin-top' : (0) + 'px',
                              'width' : parentWidth + 'px',
                            });
                          }else{
                            self.$$(popover).css({
                              'visibility' : 'visible',
                              'top' : (parentPosBottom) + 'px',
                              'margin-left' : (parentPosLeft - countryCodeWidth - margin1x) + 'px',
                              'margin-top' : (0) + 'px',
                              'width' : parentWidth + 'px',
                            });
                          }
                        }else{
                          if(type == "mobile-input"){
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'top' : (parentPosBottom) + 'px',
                                'left' : (parentPosLeft - countryCodeWidth - margin1x) + 'px',
                                'margin-top' : (0) + 'px',
                                'width' : parentWidth + 'px',
                            });
                          }else{
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'top' : (parentPosBottom) + 'px',
                                'margin-left' : (parentPosLeft) + 'px',
                                'margin-top' : (0) + 'px',
                                'width' : parentWidth + 'px',
                            });
                          }
                        }

                        self.$$(popoverInner).css({
                            'max-height' : (maxHeightBottom - (Math.abs(initHeight - fullHeight))) + 'px',
                        });
                      }
                    }
                    // POPOVER DIRECTION - OPEN IN ABOVE
                    else if(popoverDirection == "on-bottom"){
                      //console.log("POPVER OPEN IN ABOVE");
                      if(parentPosBottom < halfHeight ){
                        //console.log("DIRECTION CHANGED : OPEN IN BOTTOM")
                        self.$$(popoverInner).css({
                            'max-height' : (maxHeightBottom - (Math.abs(initHeight - fullHeight))) + 'px',
                        });                        

                        if(type == "mobile-input" || type == "fx-calculator"){
                          if(type == "mobile-input"){
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'top' : (parentPosBottom) + 'px',
                                'left' : (parentPosLeft - countryCodeWidth - 6) + 'px',
                                'margin-top' : (0) + 'px',
                                'width' : parentWidth + 'px',
                            });
                          }else{
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'top' : (parentPosBottom) + 'px',
                                'margin-left' : (parentPosLeft + 2) + 'px',
                                'margin-top' : (0) + 'px',
                                'width' : parentWidth + 'px',
                            });
                          }
                        }else{
                          self.$$(popover).css({
                              'visibility' : 'visible',
                              'top' : (parentPosBottom) + 'px',
                              'margin-left' : (parentPosLeft) + 'px',
                              'margin-top' : (0) + 'px',
                              'width' : parentWidth + 'px',
                          });
                        }
                      }else{
                        //console.log("DIRECTION STILL OPEN IN ABOVE")
                        self.$$(popoverInner).css({
                            'max-height' : (maxHeightAbove) + 'px',
                        });

                        let newHeight2 = parseFloat(document.querySelector("#"+popoverId+".modal-in").offsetHeight);
                        //console.log("newHeight2: "+newHeight2)

                        const tmpTop = fullHeight - ( (fullHeight - parentPosBottom) + newHeight2) - inputHeight - margin1x
                        
                        if(type == "mobile-input" || type == "fx-calculator"){
                          if(type == "mobile-input"){
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'margin-top' : (margin1x) + 'px',
                                'left' : (parentPosLeft - countryCodeWidth - margin1x - 2) + 'px',
                                'width' : parentWidth + 'px',
                                'top' : (tmpTop) + 'px'
                            });
                          }else{
                            self.$$(popover).css({
                                'visibility' : 'visible',
                                'margin-top' : (margin1x) + 'px',
                                'margin-left' : (parentPosLeft + 2) + 'px',
                                'width' : parentWidth + 'px',
                                'top' : (tmpTop) + 'px'
                            });
                          }
                        }else{
                          self.$$(popover).css({
                              'visibility' : 'visible',
                              'margin-top' : (margin1x) + 'px',
                              'margin-left' : (parentPosLeft) + 'px',
                              'width' : parentWidth + 'px',
                              'top' : (tmpTop) + 'px'
                          });
                        }

                      }
                    }
                  }
                },

                getDeliveryStatusName(deliveryStatusId, deliveryStatus, agentPaymentStatusId){
                  var statusName='';
                  switch(deliveryStatusId) {
                    case parseInt(process.env.VUE_APP_DELIVERY_STATUS_PENDING)    :
                      if(agentPaymentStatusId >= 10 ){
                        statusName = VueApp.$t('general-text-category-pending');
                      }else{
                        statusName = VueApp.$t('general-text-category-unpaid');
                      }
                      break;
                    case parseInt(process.env.VUE_APP_DELIVERY_STATUS_SUSPENDED)    :
                      if(agentPaymentStatusId >= 10 ){
                        statusName = VueApp.$t('general-text-category-pending');
                      }else{
                        statusName = VueApp.$t('general-text-category-unpaid');
                      }
                      break;
                    case parseInt(process.env.VUE_APP_DELIVERY_STATUS_IN_TRANSIT) : statusName = VueApp.$t('general-text-category-intransit'); break;
                    case parseInt(process.env.VUE_APP_DELIVERY_STATUS_COMPLETED)  : statusName = VueApp.$t('general-text-category-completed'); break;
                    case parseInt(process.env.VUE_APP_DELIVERY_STATUS_FAILED)     : statusName = VueApp.$t('general-text-category-unsuccesful'); break;
                    case parseInt(process.env.VUE_APP_DELIVERY_STATUS_CANCELLED)  : statusName = VueApp.$t('general-text-cancelled-status'); break;
                    case parseInt(process.env.VUE_APP_DELIVERY_STATUS_REFUNDED)   : statusName = VueApp.$t('general-text-category-refunded'); break;
                    default : statusName = deliveryStatus; break;
                  }

                  return statusName;
                },

                openMyInfoInMobile(link) {
                  // const url = new URL(link);
                  // const data = {
                  //   "type": "open_myinfo",
                  //   "auth_endpoint": url.origin + url.pathname,
                  //   "token_endpoint": "",
                  //   "client_id": url.searchParams.get('client_id'),
                  //   "state": url.searchParams.get('state'),
                  //   "scope": "",
                  //   "redirect_uri": url.searchParams.get('redirect_uri'),
                  //   "params": Object.fromEntries(url.searchParams)
                  // };

                  if(window.Android) {
                    window.Android.getMyInfoCallback(JSON.stringify({"type": "open_myinfo", "url": link}));
                  } else if(window.webkit) {
                    window.webkit.messageHandlers.MyInfoCallbackHandler.postMessage(JSON.stringify({"type": "open_myinfo", "url": link}));
                  }
                },

                isMyInfoUseInAppBrowser() {
                  return (window.Android && window.Android.getMyInfoCallback !== undefined) || (window.webkit && window.webkit.messageHandlers.MyInfoCallbackHandler !== undefined);
                },

                parseJwt(token) {
                  var base64Url = token.split('.')[1];
                  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                  var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
                      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                  }).join(''));

                  return JSON.parse(jsonPayload);
                },

                setZohoChatbotCustomer() {
                  // ARBP-33 (Zoho Chatbot SalesIq)
                  var retailBranch = "-";
                  if(this.$store.state.misc.appBranchId == 81) {
                    retailBranch = "Wandr-E Mobile";
                  } else if(this.$store.state.misc.appBranchId == 83) {
                    retailBranch = "Wandr-E Online";
                  } else if(this.$store.state.misc.appBranchId == 84) {
                    retailBranch = "Wandr-E AXS";
                  }
                  if(window.$zoho.salesiq != undefined && this.$store.state.customer != undefined && this.$store.state.customer.customerId != 0) {
                    // Set Name and Email for Zoho
                    const data = JSON.stringify({ "type": "zoho_customer_detail", 'CRN': this.$store.state.customer.customerId, "Retail Branch": retailBranch, 'name': this.$store.state.customer.customerAlias, 'email': this.$store.state.customer.email, 'mobile_no': this.$store.state.customer.mobileCountryCode + " " + this.$store.state.customer.mobile });
                    if(window.Android) {
                      window.Android.getWandrCallback(data);
                    } else if(window.webkit) {
                      window.webkit.messageHandlers.WandrCallbackHandler.postMessage(data);
                    } else {
                      window.$zoho.salesiq.visitor.name(this.$store.state.customer.customerAlias);
                      window.$zoho.salesiq.visitor.email(this.$store.state.customer.email);
                      window.$zoho.salesiq.visitor.contactnumber(this.$store.state.customer.mobileCountryCode + " " + this.$store.state.customer.mobile);
                      window.$zoho.salesiq.visitor.info({"CRN" : this.$store.state.customer.customerId, "Retail Branch": retailBranch});
                    }
                  } else if(window.$zoho.salesiq != undefined) {
                    const data = JSON.stringify({ "type": "zoho_customer_detail", 'CRN': 0, "Retail Branch": retailBranch, 'name': '', 'email': '', 'mobile_no': '+65 ' });
                    if(window.Android) {
                      window.Android.getWandrCallback(data);
                    } else if(window.webkit) {
                      window.webkit.messageHandlers.WandrCallbackHandler.postMessage(data);
                    } else {
                      window.$zoho.salesiq.visitor.name('');
                      window.$zoho.salesiq.visitor.email('');
                      window.$zoho.salesiq.visitor.contactnumber('+65 ');
                      window.$zoho.salesiq.visitor.info({"CRN" : 0, "Retail Branch": retailBranch });
                    }
                  }
                },

                capitalizeEachWord(mySentence){
                  if(mySentence.trim() != ""){
                    let words = mySentence.split(" ");

                    for (let i = 0; i < words.length; i++) {
                        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
                    }

                    return words.join(" ");
                  }
                },

                // 1: Enable Biometric, 2: Check Biometric status when Login, 3: Remove Biometric
                setCustomerUsingBiometry(customerId, type) {
                  const data = ApiService.getFormData('BioC')?JSON.parse(ApiService.getFormData('BioC')):[];
                  const generateCustomerId = customerId;
                  const index = data.indexOf(generateCustomerId);
                  if(type == 1 && index < 0) {
                    data.push(generateCustomerId);
                    ApiService.saveFormData('BioC', JSON.stringify(data));
                    ApiService.saveFormData("is_using_biometry", true);
                  } else if(type == 2 && index >= 0 && index < data.length) {
                    ApiService.saveFormData("is_using_biometry", true);
                  } else if(type == 3) {
                    ApiService.removeFormData("is_using_biometry");
                    if(index >= 0 && index < data.length) {
                      data.splice(index, 1);
                      ApiService.saveFormData('BioC', JSON.stringify(data));
                    }
                  }
                }
            }
        })
    }
}
